import React, { useState } from "react";
import {
  Grid,
  TextField,
  Typography,
  Button,
  Snackbar,
  Alert,
  Avatar,
  useMediaQuery,
  useTheme,
  IconButton
} from "@mui/material";
import { doc, setDoc } from "firebase/firestore";
import { db } from "../../../firebase";
import DynamicUploadModal from "../../../components/UploadModal";
import PhotoCamera from "@mui/icons-material/PhotoCamera";

const AddService = () => {
  const [data, setData] = useState({
    id: "", // This will be generated later
    title: "",
    subtitle: "",
    description: "",
    message: "",
    phoneno: "",
    serviceType: "",
    url: "",
    imageUrl: "",
  });
  const [uploadedImageUrl, setUploadedImageUrl] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("success");
  const [openModal, setOpenModal] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleModalClose = () => {
    setOpenModal(false);
  };

  const handleUploadSuccess = (url) => {
    setUploadedImageUrl(url);
    setData((prevData) => ({
      ...prevData,
      imageUrl: url,
    }));
  };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      // Generate a unique ID for the new document
      const newId = Date.now().toString(); // Using timestamp as a simple unique ID
      const docRef = doc(db, "services", newId);

      await setDoc(docRef, { ...data, id: newId, imageUrl: uploadedImageUrl });
      setAlertSeverity("success");
      setAlertMessage("Service added successfully!");
      // Reset the form after successful submission
      setData({
        id: "",
        title: "",
        subtitle: "",
        description: "",
        message: "",
        phoneno: "",
        serviceType: "",
        url: "",
        imageUrl: "",
      });
      setUploadedImageUrl("");
    } catch (err) {
      console.error("Error adding service:", err);
      setAlertSeverity("error");
      setAlertMessage(`Error: ${err.message}`);
    } finally {
      setShowAlert(true);
    }
  };

  const handleAlertClose = () => {
    setShowAlert(false);
  };

  return (
    <div className="App">
      <main style={{ padding: isMobile ? "10px 5px" : "20px 5px" }}>
        <Grid container justifyContent="center">
          <Grid item xs={12} sm={10} md={8} lg={6}>
            <Avatar
              alt="Service Image"
              src={uploadedImageUrl || "/placeholder.jpg"}
              style={{
                width: 100,
                height: 100,
                margin: "0 auto",
                marginBottom: 20,
              }}
            />
            <Typography variant="h6" color="#272727" align="center" gutterBottom>
              Add New Service
            </Typography>
            <form onSubmit={handleSave}>
              <Grid container spacing={isMobile ? 2 : 4}>
                <Grid item xs={12}>
                  <TextField
                    label="Title"
                    name="title"
                    value={data.title}
                    onChange={handleInputChange}
                    fullWidth
                    variant="outlined"
                    required // Title is required
                    style={{ marginTop: "16px" }}
                  />
                  <TextField
                    label="Subtitle"
                    name="subtitle"
                    value={data.subtitle}
                    onChange={handleInputChange}
                    fullWidth
                    variant="outlined"
                    style={{ marginTop: "16px" }}
                  />
                  <TextField
                    label="Description"
                    name="description"
                    value={data.description}
                    onChange={handleInputChange}
                    fullWidth
                    variant="outlined"
                    multiline
                    rows={isMobile ? 2 : 4}
                    style={{ marginTop: "16px" }}
                  />
                  <TextField
                    label="Message"
                    name="message"
                    value={data.message}
                    onChange={handleInputChange}
                    fullWidth
                    variant="outlined"
                    multiline
                    rows={isMobile ? 2 : 4}
                    style={{ marginTop: "16px" }}
                  />
                  <TextField
                    label="Phone Number"
                    name="phoneno"
                    value={data.phoneno}
                    onChange={handleInputChange}
                    fullWidth
                    variant="outlined"
                    style={{ marginTop: "16px" }}
                  />
                  <TextField
                    label="Service Type"
                    name="serviceType"
                    value={data.serviceType}
                    onChange={handleInputChange}
                    fullWidth
                    variant="outlined"
                    style={{ marginTop: "16px" }}
                  />
                  <TextField
                    label="URL"
                    name="url"
                    value={data.url}
                    onChange={handleInputChange}
                    fullWidth
                    variant="outlined"
                    style={{ marginTop: "16px" }}
                  />
                  <TextField
                    label="Image URL"
                    name="imageUrl"
                    value={uploadedImageUrl}
                    onChange={handleInputChange}
                    fullWidth
                    variant="outlined"
                    style={{ marginTop: "16px" }}
                  />
                </Grid>
                <Grid item xs={12}>
                <IconButton
                  onClick={() => setOpenModal(true)}
                  color="primary"
                  aria-label="upload image"
                >
                  <PhotoCamera />
                </IconButton>
              </Grid>
                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => setOpenModal(true)}
                    sx={{
                      marginTop: "16px",
                      width: "100%",
                    }}
                  >
                    Upload Image
                  </Button>
                </Grid>
                <Grid container justifyContent="center">
                  <Grid item>
                    <Button
                      type="submit"
                      variant="contained"
                      color="success"
                      sx={{
                        borderRadius: 15,
                        boxShadow: "none",
                        width: isMobile ? "100%" : "200px",
                        marginTop: "16px",
                      }}
                    >
                      Add Service
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </form>
            <DynamicUploadModal
              open={openModal}
              onClose={handleModalClose}
              uploadPreset="bookMyDr"
              folderName="Madecare"
              maxSize={5 * 1024 * 1024}
              onUploadSuccess={handleUploadSuccess}
            />
            <Snackbar
              open={showAlert}
              autoHideDuration={6000}
              onClose={handleAlertClose}
            >
              <Alert onClose={handleAlertClose} severity={alertSeverity} sx={{ width: "100%" }}>
                {alertMessage}
              </Alert>
            </Snackbar>
          </Grid>
        </Grid>
      </main>
    </div>
  );
};

export default AddService;
